<template>
  <div class="home">
    
    <InputHoras/>
  </div>
</template>

<script>
// @ is an alias to /src
import InputHoras from '@/components/InputHoras.vue'

export default {
  name: 'InputHorasView',
  components: {
    InputHoras,
        
  }
}
</script>
<style scoped>
.home{
  height: 100%;
}
.fc{
  height: 100%;
}
</style>
